import HeaderPortal from "components/portal/header-portal";
import { List, Icon } from "components";
import { Button } from "ui/components/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "ui/components/dropdown-menu";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { eventBus } from "utils/eventBus";
import { useRemoveTool } from "./mutation";
import CreateToolDialog from "./input";
import { MENU } from "icons/src";

export default function ToolsCasestudy() {
    const { casestudyId } = useParams();
    const [dialogOpen, setDialogOpen] = useState(false);
    const removeTool = useRemoveTool({
        onSuccess: () => {
            eventBus.emit("refresh:list", `case_studies_toolstools${casestudyId}`);
        },
    });
    const fields = [
        "id",
        "tool.name",
        "tool.type",
        "case_study.id",
    ];
    const columns = [
        {
            id: "tool.name",
            header: "Name",
            accessorKey: "tool.name",
        },
        {
            id: "tool.type",
            header: "Type",
            accessorKey: "tool.type",
            cell: ({ row }) => {
                return <span className="capitalize">{row.original?.tool?.type?.replace(/_/g, ' ')}</span>;
            }
        },
        {
            id: "actions",
            header: "",
            accessorKey: "employee.id",
            cell: ({ row }) => {
                const id = row.original.id;
                return (
                    <div className="flex items-center gap-2 justify-end opacity-0 group-hover:opacity-100 transition">
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <Button size="icon" variant="outline">
                                    <Icon icon={MENU} className="size-4" />
                                </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent>
                                <DropdownMenuItem
                                    onClick={() => removeTool.mutateAsync({ id })}
                                    disabled={removeTool.isPending}
                                    className="cursor-pointer"
                                >
                                    Delete
                                </DropdownMenuItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </div>
                );
            },
            sortable: false,
            meta: { align: "right" },
        },
    ];

    const defaultFilters = {
        case_study: {
            id: {
                _eq: casestudyId,
            }
        },
    };

    const handleCreate = () => {
        setDialogOpen(true);
    };

    return (
        <div className="flex-1">
            <HeaderPortal>
                <Button onClick={handleCreate}>
                    Add
                </Button>
            </HeaderPortal>
            <List
                title="Tools"
                storageKey={`tools${casestudyId}`}
                endPoint="case_studies_tools"
                filters={defaultFilters}
                columns={columns}
                meta={{ fields }}
                hidePagination={true}
                showSearch={false}
                perPage={10}
                sortBy="tool.name"
            />
            <CreateToolDialog
                open={dialogOpen}
                onOpenChange={setDialogOpen}
            />
        </div>
    );
};
